module.exports = __webpack_public_path__ + "static/media/IMG_0028.c74afcc5.jpg";